export function rxsecret () {
  const result = []
  result.web_port = 4444
  result.base_api = "https://zdbapi.bonanhem.com";
  result.theme = 'default'
  return result
}
